import { useState } from 'react';
import { api } from '../lib/api';

export function InstallPage() {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    adminEmail: '', adminPassword: '', confirm: '', adminPort: '3019', adminEntry: 'admin', adminAccessCode: '',
    dbType: 'sqlite', dbHost: '', dbPort: '', dbName: '', dbUser: '', dbPassword: '',
    deployMode: 'direct', deployRole: 'single', domain: '', enableHttps: false, publicPort: '3018',
    selfAddress: '', peerAddress: '', syncToken: '',
    adminBindHost: '127.0.0.1', adminAllowedIps: '', adminAllowedMacs: '',
    tunnelMode: 'off', tunnelServer: '', tunnelToken: '',
  });
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [deployFile, setDeployFile] = useState('');
  const [deployConfig, setDeployConfig] = useState('');
  const [haFile, setHaFile] = useState('');
  const [haConfig, setHaConfig] = useState('');
  const [tunnelFiles, setTunnelFiles] = useState<string[]>([]);
  const [tunnelNotes, setTunnelNotes] = useState<string[]>([]);

  const genToken = () => setForm({ ...form, syncToken: Array.from({ length: 32 }, () => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'[Math.floor(Math.random() * 62)]).join('') });

  const next = () => {
    setError('');
    if (step === 1) {
      if (form.dbType !== 'sqlite') {
        if (!form.dbHost || !form.dbName) { setError('数据库主机和库名必填'); return; }
      }
    }
    if (step === 2) {
      if (!form.adminEmail || !form.adminPassword) { setError('邮箱和密码必填'); return; }
      if (form.adminPassword !== form.confirm) { setError('两次密码不一致'); return; }
    }
    if (step === 3) {
      if (!form.adminPort || !form.adminEntry) { setError('端口和安全入口必填'); return; }
    }
    if (step === 4) {
      if (form.deployMode !== 'direct' && !form.domain) { setError('反向代理模式必须填写域名（server_name）'); return; }
      if (!form.publicPort) { setError('公开服务端口必填'); return; }
      if (form.deployRole !== 'single') {
        if (!form.peerAddress) { setError('双机模式必须填写对端主机地址'); return; }
        if (!form.syncToken) { setError('双机模式必须设置对等同步令牌（两台机器需一致）'); return; }
      }
    }
    setStep(step + 1);
  };

  const submit = async () => {
    setError('');
    const r = await fetch(api('/api/install/setup'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    const d = await r.json();
    if (!r.ok) { setError(d.error || '安装失败'); return; }
    if (d.deployFile) setDeployFile(d.deployFile);
    if (d.deployConfig) setDeployConfig(d.deployConfig);
    if (d.haFile) setHaFile(d.haFile);
    if (d.haConfig) setHaConfig(d.haConfig);
    if (d.tunnelFiles) setTunnelFiles(d.tunnelFiles);
    if (d.tunnelNotes) setTunnelNotes(d.tunnelNotes);
    setDone(true);
  };

  if (done) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] text-gray-100 flex items-center justify-center px-4 py-10">
        <div className="text-center max-w-2xl w-full">
          <div className="text-6xl mb-6">✅</div>
          <h1 className="text-2xl font-bold mb-3">安装完成</h1>
          <p className="text-gray-400 mb-6">服务正在重启，请稍候...</p>
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-4 text-left text-sm text-gray-400 space-y-2 mb-6">
            <div>管理后台：<span className="text-cyan-400">http://你的服务器:{form.adminPort}/{form.adminEntry}/login</span></div>
            <div>登录邮箱：<span className="text-cyan-400">{form.adminEmail}</span></div>
            {form.adminAccessCode && <div>安全登录码：<span className="text-cyan-400">{form.adminAccessCode}</span></div>}
            {form.deployMode !== 'direct' && (
              <>
                <div>部署模式：<span className="text-cyan-400">{form.deployMode === 'nginx' ? 'Nginx 反代' : 'Apache 反代'}（{form.domain}）</span></div>
                <div>主机角色：<span className="text-cyan-400">{form.deployRole === 'single' ? '单机部署' : form.deployRole === 'primary' ? '双机·主节点' : '双机·备节点'}</span></div>
                {form.deployRole !== 'single' && (
                  <>
                    <div>对端主机：<span className="text-cyan-400">{form.peerAddress}</span> · 同步令牌：<span className="text-cyan-400">{form.syncToken}</span></div>
                    <div>本机反代配置：<span className="text-emerald-400">{deployFile}</span></div>
                    <div>双机负载均衡入口配置：<span className="text-emerald-400">{haFile}</span></div>
                  </>
                )}
                <div>配置文件：<span className="text-emerald-400">{deployFile}</span></div>
              </>
            )}
          </div>

          {form.deployMode !== 'direct' && deployConfig && (
            <div className="text-left mb-6">
              <div className="flex items-center justify-between mb-2">
                <h2 className="text-sm font-semibold text-gray-300">{form.deployRole !== 'single' ? '本机反向代理配置（两台主机均使用，域名相同）' : '已生成的反向代理配置（可复制到服务器 ' + form.deployMode + ' 配置目录）'}</h2>
                <button
                  onClick={() => { navigator.clipboard?.writeText(deployConfig); }}
                  className="px-3 py-1 text-xs bg-cyan-500/20 text-cyan-400 rounded hover:bg-cyan-500/30"
                >复制配置</button>
              </div>
              <pre className="bg-gray-950 border border-gray-800 rounded-lg p-4 text-xs text-cyan-300/80 overflow-x-auto max-h-96 whitespace-pre-wrap break-all font-mono">{deployConfig}</pre>
            </div>
          )}

          {form.deployMode !== 'direct' && form.deployRole !== 'single' && haConfig && (
            <div className="text-left mb-6">
              <div className="flex items-center justify-between mb-2">
                <h2 className="text-sm font-semibold text-gray-300">双机负载均衡入口配置（部署在有公网 IP 的入口机，外网随机访问任意一台均完整服务）</h2>
                <button
                  onClick={() => { navigator.clipboard?.writeText(haConfig); }}
                  className="px-3 py-1 text-xs bg-cyan-500/20 text-cyan-400 rounded hover:bg-cyan-500/30"
                >复制配置</button>
              </div>
              <pre className="bg-gray-950 border border-gray-800 rounded-lg p-4 text-xs text-cyan-300/80 overflow-x-auto max-h-96 whitespace-pre-wrap break-all font-mono">{haConfig}</pre>
            </div>
          )}

            {form.deployMode !== 'direct' && (
              <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-4 text-left text-sm text-gray-400 mb-6">
                <h2 className="text-sm font-semibold text-gray-300 mb-2">部署步骤（{form.deployMode === 'nginx' ? 'Nginx' : 'Apache'}）</h2>
                <ol className="list-decimal list-inside space-y-1 text-xs">
                  <li>将上面配置保存到 {form.deployMode === 'nginx' ? '/etc/nginx/conf.d/freerouter.conf（或 sites-available）' : '/etc/apache2/sites-available/freerouter.conf'} 并放入 SSL 证书</li>
                  <li>{form.deployMode === 'nginx' ? 'nginx -t 校验后 nginx -s reload' : 'a2enmod proxy proxy_http ssl 后 systemctl reload apache2'}</li>
                  <li>确保本项目进程由 PM2 / systemd 托管（公开端口 {form.publicPort}、后台端口 {form.adminPort}）</li>
                  <li>防火墙放行 80/443，域名解析指向本机，即可通过 https://{form.domain} 访问</li>
                  {form.deployRole !== 'single' && (
                    <>
                      <li>双机模式：两台主机均部署上述相同配置（域名一致），并把 HA 负载均衡入口配置部署到有公网 IP 的入口机（可为其中一台），nginx -t 后 reload</li>
                      <li>两台的 PeerSync 对等同步（令牌一致、互填对方地址）默认 60s 双向收敛目录数据；外网轮询落到任意一台均完整服务</li>
                      <li>管理后台 /admin 在入口配置中单点路由到主节点（管理操作单写者）；建议只在一台开启智能体</li>
                    </>
                  )}
                </ol>
              </div>
            )}

            {form.tunnelMode !== 'off' && tunnelFiles.length > 0 && (
              <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-4 text-left text-sm text-gray-400 mb-6">
                <h2 className="text-sm font-semibold text-gray-300 mb-2">内网穿透（{form.tunnelMode === 'frp' ? 'frp' : 'Cloudflare Tunnel'}）已生成配置</h2>
                <div className="text-xs text-emerald-400 space-y-1 mb-2">
                  {tunnelFiles.map((f, i) => <div key={i}>• {f}</div>)}
                </div>
                <div className="text-xs space-y-1">
                  {tunnelNotes.map((n, i) => <div key={i}>• {n}</div>)}
                </div>
              </div>
            )}

          <p className="text-xs text-gray-500 mt-4">重启完成后请刷新页面。如修改了安全入口，需以相同 VITE_ADMIN_ENTRY 重新构建前端。</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-gray-100 flex items-center justify-center px-4">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold gradient-text mb-2">CXAI-FreeRouter 安装向导</h1>
          <p className="text-sm text-gray-500">步骤 {step + 1} / 6</p>
        </div>

        <div className="flex gap-2 mb-8">
          {[0, 1, 2, 3, 4, 5].map(i => (
            <div key={i} className={`flex-1 h-1 rounded ${i <= step ? 'bg-cyan-500' : 'bg-gray-800'}`} />
          ))}
        </div>

        {step === 0 && (
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6">
            <h2 className="text-lg font-semibold mb-4">欢迎使用 CXAI-FreeRouter</h2>
            <p className="text-sm text-gray-400 mb-4">本向导将引导你完成初始部署配置。完成后服务将自动重启生效。</p>
            <ul className="text-sm text-gray-500 space-y-2 mb-6">
              <li>• 选择数据库类型（SQLite / MySQL / PostgreSQL）</li>
              <li>• 设置管理员登录账号与密码</li>
              <li>• 配置管理后台独立端口与安全入口</li>
              <li>• 选择部署方式（直接端口 / Nginx / Apache 反向代理）</li>
              <li>• 选择主机角色：单机部署 或 双机主/备（相同域名 + 负载均衡 + PeerSync 双向同步）</li>
              <li>• 自动生成 Nginx/Apache 反代配置（支持 HTTPS 443）与双机 HA 入口配置</li>
            </ul>
            <button onClick={next} className="w-full px-4 py-2 bg-cyan-500/20 text-cyan-400 rounded-lg hover:bg-cyan-500/30">开始安装</button>
          </div>
        )}

        {step === 1 && (
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 space-y-4">
            <h2 className="text-lg font-semibold">数据库配置</h2>
            <div>
              <label className="text-sm text-gray-400 block mb-2">数据库类型</label>
              <div className="grid grid-cols-3 gap-2">
                {(['sqlite', 'mysql', 'postgresql'] as const).map(t => (
                  <button key={t} onClick={() => setForm({ ...form, dbType: t, dbPort: t === 'mysql' ? '3306' : t === 'postgresql' ? '5432' : '' })}
                    className={`px-3 py-2 rounded text-sm border ${form.dbType === t ? 'border-cyan-500 bg-cyan-500/20 text-cyan-400' : 'border-gray-800 text-gray-400 hover:border-gray-600'}`}>
                    {t === 'sqlite' ? 'SQLite' : t === 'mysql' ? 'MySQL' : 'PostgreSQL'}
                  </button>
                ))}
              </div>
              {form.dbType === 'sqlite' && <p className="text-xs text-gray-500 mt-2">数据存储在本地文件，无需额外配置</p>}
            </div>
            {form.dbType !== 'sqlite' && (
              <>
                <div>
                  <label className="text-sm text-gray-400 block mb-1">主机地址</label>
                  <input value={form.dbHost} onChange={e => setForm({ ...form, dbHost: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="127.0.0.1" />
                </div>
                <div>
                  <label className="text-sm text-gray-400 block mb-1">端口</label>
                  <input value={form.dbPort} onChange={e => setForm({ ...form, dbPort: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder={form.dbType === 'mysql' ? '3306' : '5432'} />
                </div>
                <div>
                  <label className="text-sm text-gray-400 block mb-1">数据库名</label>
                  <input value={form.dbName} onChange={e => setForm({ ...form, dbName: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="freerouter" />
                </div>
                <div>
                  <label className="text-sm text-gray-400 block mb-1">用户名</label>
                  <input value={form.dbUser} onChange={e => setForm({ ...form, dbUser: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="root" />
                </div>
                <div>
                  <label className="text-sm text-gray-400 block mb-1">密码</label>
                  <input value={form.dbPassword} onChange={e => setForm({ ...form, dbPassword: e.target.value })} type="password" className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="••••••••" />
                </div>
              </>
            )}
            {error && <div className="text-sm text-red-400">{error}</div>}
            <button onClick={next} className="w-full px-4 py-2 bg-cyan-500/20 text-cyan-400 rounded-lg hover:bg-cyan-500/30">下一步</button>
          </div>
        )}

        {step === 2 && (
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 space-y-4">
            <h2 className="text-lg font-semibold">管理员账号</h2>
            <div>
              <label className="text-sm text-gray-400 block mb-1">登录邮箱</label>
              <input value={form.adminEmail} onChange={e => setForm({ ...form, adminEmail: e.target.value })} type="email" className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="admin@example.com" />
            </div>
            <div>
              <label className="text-sm text-gray-400 block mb-1">登录密码</label>
              <input value={form.adminPassword} onChange={e => setForm({ ...form, adminPassword: e.target.value })} type="password" className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="••••••••" />
            </div>
            <div>
              <label className="text-sm text-gray-400 block mb-1">确认密码</label>
              <input value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })} type="password" className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="••••••••" />
            </div>
            {error && <div className="text-sm text-red-400">{error}</div>}
            <button onClick={next} className="w-full px-4 py-2 bg-cyan-500/20 text-cyan-400 rounded-lg hover:bg-cyan-500/30">下一步</button>
          </div>
        )}

        {step === 3 && (
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 space-y-4">
            <h2 className="text-lg font-semibold">管理后台安全设置</h2>
            <div>
              <label className="text-sm text-gray-400 block mb-1">管理后台端口</label>
              <input value={form.adminPort} onChange={e => setForm({ ...form, adminPort: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="3019" />
              <p className="text-xs text-gray-500 mt-1">独立端口，不与公开站点共用</p>
            </div>
            <div>
              <label className="text-sm text-gray-400 block mb-1">安全入口路径</label>
              <input value={form.adminEntry} onChange={e => setForm({ ...form, adminEntry: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="admin" />
              <p className="text-xs text-gray-500 mt-1">访问 http://端口/&lt;入口&gt;/login 进入后台，建议改为不易猜到的路径</p>
            </div>
            <div>
              <label className="text-sm text-gray-400 block mb-1">安全登录码（推荐设置）</label>
              <input value={form.adminAccessCode} onChange={e => setForm({ ...form, adminAccessCode: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="留空则不校验" />
              <p className="text-xs text-gray-500 mt-1">登录时除邮箱密码外还需输入此码</p>
            </div>
            {error && <div className="text-sm text-red-400">{error}</div>}
            <button onClick={next} className="w-full px-4 py-2 bg-cyan-500/20 text-cyan-400 rounded-lg hover:bg-cyan-500/30">下一步</button>
          </div>
        )}

        {step === 4 && (
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 space-y-4">
            <h2 className="text-lg font-semibold">部署配置</h2>
            <div>
              <label className="text-sm text-gray-400 block mb-2">部署方式</label>
              <div className="grid grid-cols-3 gap-2">
                {([
                  { id: 'direct', label: '端口直连', desc: '直接通过 3018/3019 端口访问' },
                  { id: 'nginx', label: 'Nginx 反代', desc: '生成 Nginx 反代配置（80/443）' },
                  { id: 'apache', label: 'Apache 反代', desc: '生成 Apache VirtualHost 配置' },
                ] as const).map(t => (
                  <button key={t.id} onClick={() => setForm({ ...form, deployMode: t.id })}
                    className={`px-3 py-2 rounded text-sm border text-left ${form.deployMode === t.id ? 'border-cyan-500 bg-cyan-500/20 text-cyan-400' : 'border-gray-800 text-gray-400 hover:border-gray-600'}`}>
                    <div className="font-medium">{t.label}</div>
                    <div className="text-xs mt-1 opacity-70">{t.desc}</div>
                  </button>
                ))}
              </div>
            </div>
            {form.deployMode !== 'direct' && (
              <>
                <div className="border-t border-gray-800 pt-3">
                  <label className="text-sm text-gray-400 block mb-2">主机角色（部署模式）</label>
                  <div className="grid grid-cols-3 gap-2">
                    {([
                      { id: 'single', label: '单机部署', desc: '一台主机独立对外' },
                      { id: 'primary', label: '双机·主节点', desc: '两台相同域名，本机为主' },
                      { id: 'backup', label: '双机·备节点', desc: '两台相同域名，本机为备' },
                    ] as const).map(t => (
                      <button key={t.id} onClick={() => setForm({ ...form, deployRole: t.id })}
                        className={`px-3 py-2 rounded text-sm border text-left ${form.deployRole === t.id ? 'border-cyan-500 bg-cyan-500/20 text-cyan-400' : 'border-gray-800 text-gray-400 hover:border-gray-600'}`}>
                        <div className="font-medium">{t.label}</div>
                        <div className="text-xs mt-1 opacity-70">{t.desc}</div>
                      </button>
                    ))}
                  </div>
                  {form.deployRole !== 'single' && (
                    <div className="mt-3 space-y-3">
                      <p className="text-xs text-cyan-400/80">双机冗余：两台主机使用<b>相同域名</b>，各自跑完整服务；目录/内容数据经 PeerSync 双向同步，入口负载均衡随机访问任意一台均完整服务，一台故障自动切换。单机也可独立使用本安装向导。</p>
                      <div>
                        <label className="text-sm text-gray-400 block mb-1">本机地址（公网/内网 IP，用于生成负载均衡 upstream）</label>
                        <input value={form.selfAddress} onChange={e => setForm({ ...form, selfAddress: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="192.168.1.10" />
                      </div>
                      <div>
                        <label className="text-sm text-gray-400 block mb-1">对端主机地址（另一台的 IP）</label>
                        <input value={form.peerAddress} onChange={e => setForm({ ...form, peerAddress: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="192.168.1.20" />
                        <p className="text-xs text-gray-500 mt-1">两台安装时角色互换填写：主节点填备机 IP，备节点填主机 IP</p>
                      </div>
                      <div>
                        <label className="text-sm text-gray-400 block mb-1">对等同步令牌（两台必须一致，PeerSync 鉴权）</label>
                        <div className="flex gap-2">
                          <input value={form.syncToken} onChange={e => setForm({ ...form, syncToken: e.target.value })} type="password" className="flex-1 px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm font-mono" placeholder="两台填写相同的安全令牌" />
                          <button onClick={genToken} className="px-3 py-2 text-xs bg-cyan-500/20 text-cyan-400 rounded hover:bg-cyan-500/30 whitespace-nowrap">生成</button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <label className="text-sm text-gray-400 block mb-1">域名（server_name，双机时两台相同）</label>
                  <input value={form.domain} onChange={e => setForm({ ...form, domain: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="api.example.com" />
                  <p className="text-xs text-gray-500 mt-1">用于生成反代配置与 SSL 证书路径，需先解析到本机</p>
                </div>
                <div>
                  <label className="text-sm text-gray-400 block mb-1">公开服务端口（反代上游）</label>
                  <input value={form.publicPort} onChange={e => setForm({ ...form, publicPort: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="3018" />
                  <p className="text-xs text-gray-500 mt-1">本项目公开服务监听端口，无需对公网开放</p>
                </div>
                <div className="flex items-center gap-2">
                  <input id="https" type="checkbox" checked={form.enableHttps} onChange={e => setForm({ ...form, enableHttps: e.target.checked })} className="accent-cyan-500" />
                  <label htmlFor="https" className="text-sm text-gray-400">启用 HTTPS（443，需准备 SSL 证书）</label>
                </div>
                {form.enableHttps && (
                  <p className="text-xs text-yellow-400/80">安装完成后请将证书放置于 /etc/nginx/ssl/{form.domain || 'example.com'}.crt（或 Apache 对应目录），并取消证书注释。</p>
                )}
              </>
            )}

            <div className="border-t border-gray-800 pt-4">
              <h3 className="text-sm font-semibold text-gray-300 mb-3">管理后台访问控制</h3>
              <div>
                <label className="text-sm text-gray-400 block mb-1">监听地址（绑定 IP）</label>
                <input value={form.adminBindHost} onChange={e => setForm({ ...form, adminBindHost: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="127.0.0.1" />
                <p className="text-xs text-gray-500 mt-1">默认仅本机；可填 0.0.0.0（所有）或指定 IP（如 192.168.1.100）供局域网访问</p>
              </div>
              <div>
                <label className="text-sm text-gray-400 block mb-1">允许来源 IP 白名单</label>
                <input value={form.adminAllowedIps} onChange={e => setForm({ ...form, adminAllowedIps: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="192.168.1.100 或 192.168.1.0/24 或 lan（留空=仅本机）" />
                <p className="text-xs text-gray-500 mt-1">逗号分隔：单 IP / CIDR 网段 / lan（全部内网段）/ all。反代部署时设置 TRUST_PROXY=1 后按真实 IP 校验</p>
              </div>
              <div>
                <label className="text-sm text-gray-400 block mb-1">MAC 白名单（可选，局域网绑定登录）</label>
                <input value={form.adminAllowedMacs} onChange={e => setForm({ ...form, adminAllowedMacs: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="AA-BB-CC-DD-EE-FF,11-22-33-44-55-66（留空=不校验）" />
                <p className="text-xs text-gray-500 mt-1">仅当管理设备与服务器同一局域网（ARP 表可解析）时生效；跨网段/公网无法解析 MAC 将一律拒绝</p>
              </div>
            </div>

            <div className="border-t border-gray-800 pt-4">
              <h3 className="text-sm font-semibold text-gray-300 mb-3">内网穿透（服务器无公网 IP 时向互联网提供服务）</h3>
              <div className="grid grid-cols-3 gap-2">
                {([
                  { id: 'off', label: '关闭', desc: '需公网 IP 或反代' },
                  { id: 'frp', label: 'frp', desc: '自建 frps 服务器中转' },
                  { id: 'cloudflared', label: 'Cloudflare', desc: '官方隧道免公网 IP' },
                ] as const).map(t => (
                  <button key={t.id} onClick={() => setForm({ ...form, tunnelMode: t.id })}
                    className={`px-3 py-2 rounded text-sm border text-left ${form.tunnelMode === t.id ? 'border-cyan-500 bg-cyan-500/20 text-cyan-400' : 'border-gray-800 text-gray-400 hover:border-gray-600'}`}>
                    <div className="font-medium">{t.label}</div>
                    <div className="text-xs mt-1 opacity-70">{t.desc}</div>
                  </button>
                ))}
              </div>
              {form.tunnelMode === 'frp' && (
                <>
                  <div className="mt-3">
                    <label className="text-sm text-gray-400 block mb-1">frps 服务器地址</label>
                    <input value={form.tunnelServer} onChange={e => setForm({ ...form, tunnelServer: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="vps.example.com:7000" />
                  </div>
                  <div>
                    <label className="text-sm text-gray-400 block mb-1">frp 认证 token</label>
                    <input value={form.tunnelToken} onChange={e => setForm({ ...form, tunnelToken: e.target.value })} type="password" className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="与 frps 端一致" />
                  </div>
                </>
              )}
              {form.tunnelMode === 'cloudflared' && (
                <div className="mt-3">
                  <label className="text-sm text-gray-400 block mb-1">公网域名（可选，Named Tunnel）</label>
                  <input value={form.tunnelServer} onChange={e => setForm({ ...form, tunnelServer: e.target.value })} className="w-full px-3 py-2 bg-gray-900 border border-gray-800 rounded text-sm" placeholder="example.com（留空使用免域名 Quick Tunnel）" />
                </div>
              )}
              {form.tunnelMode !== 'off' && (
                <p className="text-xs text-yellow-400/80 mt-2">安装完成页将展示生成的隧道配置与启动脚本（deploy/tunnel/），需下载 frpc / cloudflared 二进制后启动。</p>
              )}
            </div>

            {error && <div className="text-sm text-red-400">{error}</div>}
            <button onClick={next} className="w-full px-4 py-2 bg-cyan-500/20 text-cyan-400 rounded-lg hover:bg-cyan-500/30">下一步</button>
          </div>
        )}

        {step === 5 && (
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 space-y-4">
            <h2 className="text-lg font-semibold">确认配置</h2>
            <div className="text-sm text-gray-400 space-y-2 bg-gray-900/50 rounded p-4">
              <div>数据库：<span className="text-cyan-400">{form.dbType === 'sqlite' ? 'SQLite' : form.dbType === 'mysql' ? `MySQL ${form.dbHost}:${form.dbPort}/${form.dbName}` : `PostgreSQL ${form.dbHost}:${form.dbPort}/${form.dbName}`}</span></div>
              <div>管理员邮箱：<span className="text-cyan-400">{form.adminEmail}</span></div>
              <div>管理端口：<span className="text-cyan-400">{form.adminPort}</span></div>
              <div>安全入口：<span className="text-cyan-400">/{form.adminEntry}</span></div>
              <div>安全登录码：<span className="text-cyan-400">{form.adminAccessCode || '不设置'}</span></div>
              <div>部署方式：<span className="text-cyan-400">{form.deployMode === 'direct' ? '端口直连' : form.deployMode === 'nginx' ? `Nginx 反代 → ${form.domain}${form.enableHttps ? '（HTTPS 443）' : '（HTTP 80）'}` : `Apache 反代 → ${form.domain}${form.enableHttps ? '（HTTPS 443）' : '（HTTP 80）'}`}</span></div>
              <div>主机角色：<span className="text-cyan-400">{form.deployRole === 'single' ? '单机部署' : form.deployRole === 'primary' ? '双机·主节点' : '双机·备节点'}</span>{form.deployRole !== 'single' && <span> · 本机 <span className="text-cyan-400">{form.selfAddress || '待填'}</span> ↔ 对端 <span className="text-cyan-400">{form.peerAddress}</span></span>}</div>
              <div>后台监听：<span className="text-cyan-400">{form.adminBindHost}</span> · 来源白名单：<span className="text-cyan-400">{form.adminAllowedIps || '仅本机'}</span>{form.adminAllowedMacs ? ` · MAC：${form.adminAllowedMacs.split(',').length} 台` : ''}</div>
              <div>内网穿透：<span className="text-cyan-400">{form.tunnelMode === 'off' ? '关闭' : form.tunnelMode === 'frp' ? `frp → ${form.tunnelServer || '待填服务器'}` : `Cloudflare Tunnel${form.tunnelServer ? ` → ${form.tunnelServer}` : '（免域名）'}`}</span></div>
            </div>
            <p className="text-xs text-yellow-400/80">⚠ 安装完成后服务将自动重启，请确保使用 PM2 等进程管理器托管。选择反代模式时会自动生成并保存部署配置文件。</p>
            {error && <div className="text-sm text-red-400">{error}</div>}
            <button onClick={submit} className="w-full px-4 py-2 bg-emerald-500/20 text-emerald-400 rounded-lg hover:bg-emerald-500/30">确认安装</button>
            <button onClick={() => setStep(4)} className="w-full px-4 py-2 text-gray-500 text-sm hover:text-gray-300">返回修改</button>
          </div>
        )}
      </div>
    </div>
  );
}
